/* eslint-disable no-unused-vars */

import { createSelector, createSlice } from "@reduxjs/toolkit";

import _ from "lodash";
import {
  apolloConnect,
  apolloGetInformation,
  deleteInTeam,
  editGroupRule,
  getCustomPaymentId,
  getIntegrationLeadsApollo,
  getIntegrationLeadsHubspot,
  getIntegrationLeadsSalesforce,
  getUser,
  gettimezones,
  hubspotConnect,
  hubspotGetInformation,
  initiateAndGetAllUserInfo,
  patchSettings,
  salesforceConnect,
  salesforceGetInformation,
  saveDialerMapping,
  saveTeamConnection,
  teamMemCreate,
  updRoleInTeam,
  updSchedTeamBe,
  updTeamSchedInTeam,
} from "./asyncRequests";
import { updateMeeting } from "../reactive-links-settings/asyncRequests";
import { getProsFiles } from "../prospect_data/asyncRequests";
import { patchEmailSettings } from "../outreach-emails/asyncRequests";
import {
  assignContactsInAccountCampaign,
  assignmentsToUpl,
  editContactsInAccountAllow,
  editContactsInAccountCampaign,
  editContactsInAccountDelete,
  editContactsInAccountStop,
  generateOneAiEmail,
  uploadLeadFileAndColumnInd,
} from "../outreach-campaigns/asyncRequests";
import { skipTrialNow } from "../stripe/asyncRequests";

type ErrorType = null | string;

const INITIAL_STATE = {
  user: {}, // do not reload this, it will put the dashboard in an unclickable loading mode. Only during upgrade/downgrade do that.
  settings: {},
  timezones: [],

  idArrExpToSee: [] as number[],
  idArrLoadedUp: [] as number[],
  // idArrExpToSee: null as null | number[],
  // idArrLoadedUp: null as null | number[],

  error: null as ErrorType,
  loading: false,
  settingsLoading: false,
  account_status: null,
  show_softdeleted_popup: false,
  is_notifications_insist: false,
  payingClient: false,
  trialClient: false,
  tutorialRun: false,
  openActivateModalTrialSkip: false,
  sdBarCollapsed: false, // ui menucollapsed
  showTutorial: false, // not used

  forceUserRefresh: false, // this is for when users role changes/ team view mode changes

  team: { hasTeam: false, clientWithTeam: {}, teamProsCnt: [], contacts_team_can_have: 0 },
  loadingSaveTeam: false,
  planToDisplay: null,
  planToDisplayLoading: true,
  editingTeamsLoading: false,
  successfullUpdateMsgTeam: false as boolean | string,
  infoUpdateMsgTeam: false as boolean | string,
  failedUpdateMsgTeam: false as boolean | string,

  // integration
  successfullIntegration: false as boolean | string,
  infoIntegration: false as boolean | string,
  failedIntegration: false as boolean | string,
  uplIntegrationLoading: false as boolean | string,
  integrationListTeamHas: [],
  fetchingExtLeadsLoading: false as boolean | string,

  // apollo leadupl info
  salesforceTotalCnt: 0 as number | null | string,
  fetchingSalesforceLeadsDataLoading: false as boolean | string,
  teamLeadsHaveSalesforce: [],
  apolloTotalCnt: 0 as number | null | string,
  teamLeadsHave: [],
  fetchingApolloLeadsDataLoading: false as boolean | string,
  teamLeadsHaveHubspot: [],
  hubspotTotalCnt: 0 as number | null | string,
  fetchingHubspotLeadsDataLoading: false as boolean | string,

  // lead upload stat
  successfullLeadUplStatus: false as boolean | string,
  infoLeadUplStatus: false as boolean | string,
  failedLeadUplStatus: false as boolean | string,
};

function loadingFailed(state: { error: any }, action: { payload: any }) {
  state.error = action.payload;
}
interface LogoutAction {
  type: string;
  payload: {
    error: string | null; // Adjust the type of error property here
  };
}
const userSlice = createSlice({
  name: "user",
  initialState: INITIAL_STATE,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    logout: (state, action) => {
      // console.log(action, "logout");
      // console.log('islogout');
      const isIframe = window.self !== window.top;
      if (isIframe) {
        window.parent.postMessage({ type: "REMOVE_TOKEN", tokenName: "token" }, "*");
      } else {
        localStorage.clear();
      }
      state.user = {};
      state.error = action?.payload?.error || null;
      state.account_status = null;
      state.show_softdeleted_popup = false;
      state.loading = false;
    },
    resetLeadUplStat: (state) => {
      state.successfullLeadUplStatus = false;
      state.infoLeadUplStatus = false;
      state.failedLeadUplStatus = false;
    },
    resetIntegrationStat: (state) => {
      state.successfullIntegration = false;
      state.infoIntegration = false;
      state.failedIntegration = false;
    },
    setNotificationsInsist: (state) => {
      state.is_notifications_insist = true;
    },
    idArrExpectedToSee: (state, action) => {
      state.idArrExpToSee = action.payload;
    },
    SetColapsedSdBar: (state, action) => {
      state.sdBarCollapsed = action.payload;
    },
    setSkipTrial: (state, action) => {
      state.openActivateModalTrialSkip = action.payload;
    },
    resOutcomeTeam: (state) => {
      state.successfullUpdateMsgTeam = false;
      state.infoUpdateMsgTeam = false;
      state.failedUpdateMsgTeam = false;
    },
    ShowTutorialNow: (state) => {
      state.showTutorial = true; // this works for the video not for the passing through one
    },

    setTutorialRun: (state, action) => {
      state.tutorialRun = action.payload;
    },
    closeAssigningArr: (state) => {
      const deepCopiedUser = _.cloneDeep(state.user);
      deepCopiedUser.pros_uploaded_that_need_assigning = null;
      state.user = deepCopiedUser;
    },
    hideTutorialNow: (state) => {
      state.showTutorial = false;
    },
    updPersSchedGroup: (state, action) => {
      const name = action.payload?.teamGroupName;
      const email = action.payload?.email;
      console.log(name, "namenamename", email);
      // const inactivated_emails = state.team?.clientWithTeam?.pageInfo?.data?.inactivated_emails;
      const team_members = state.team?.clientWithTeam?.pageInfo?.data?.team_members;

      const teamToUpd = _.cloneDeep(state.team);
      // if (inactivated_emails) {
      //   const inactivatedEmailIndex = inactivated_emails.findIndex((member: any) => member.email === email);
      //   if (inactivatedEmailIndex !== -1) {
      //     teamToUpd.clientWithTeam.pageInfo.data.inactivated_emails[inactivatedEmailIndex].type = role;
      //   }
      // }

      if (team_members) {
        const teamMemberIndex = team_members.findIndex((member: any) => member.email?.trim()?.toLowerCase() === email?.trim()?.toLowerCase());

        if (teamMemberIndex !== -1) {
          teamToUpd.clientWithTeam.pageInfo.data.team_members[teamMemberIndex].upd_group_name = name;
          // teamToUpd.clientWithTeam.pageInfo.data.team_members[teamMemberIndex].upd_group_color = color;
        } else {
          // teamToUpd.clientWithTeam.pageInfo.data.team_members[teamMemberIndex].upd_group_name = null;
        }
      }

      state.team = teamToUpd;
    },
    setError: loadingFailed,
    // toggleTutorialStatus: (state) => {
    //   state.user.is_show_tutorial = !state.user.is_show_tutorial;
    //   state.user.new_account = !state.user.new_account;
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initiateAndGetAllUserInfo.fulfilled, (state, action) => {
        // console.log(action.payload, "settings");
        state.settings = action.payload.settings;
        state.team = action.payload.team;
        state.integrationListTeamHas = action.payload.integrationListTeamHas;
        state.idArrLoadedUp = action.payload.idArrLoadedUp;
      })
      .addCase(getUser.pending, (state) => {
        if (!state.loading) {
          state.loading = true;
        }
      })
      .addCase(getUser.fulfilled, (state, action: any) => {
        if (state.loading) {
          state.loading = false;
        }

        // console.log("USERREQ=SUCCESS");
        const client = action.payload;
        state.payingClient = client?.new_payment_status === "successfully_on" && client?.new_subscription_plans;
        state.trialClient = client?.new_payment_status === "trial" && client?.new_subscription_plans;
        // console.log(client?.new_payment_status, client?.new_subscription_plans, "client?.new_subscription_plans");
        // console.log(client, "clientclient");
        state.user = client;
        state.idArrExpToSee = client?.team_viewing_ids_now_arr || [client?.id];
        state.idArrLoadedUp = client?.team_viewing_ids_now_arr || [client?.id];
      })
      .addCase(uploadLeadFileAndColumnInd.fulfilled, (state, action) => {
        // const { res,   } = action?.payload;
        // res?.prosUplStatus;
        const deepCopiedUser = _.cloneDeep(state.user);
        deepCopiedUser.pros_uploaded_that_need_assigning = action.payload.res?.prosUplStatus;
        state.user = deepCopiedUser;
        const team = _.cloneDeep(state.team);
        console.log(!!team, team.teamProsCnt, action.payload, "uploadLeadFileAndColumnIndUPLOAAAA");
        if (team && team.teamProsCnt) {
          team.teamProsCnt = action.payload.teamAmnt;
        }
        state.team = team;
      })
      .addCase(assignmentsToUpl.fulfilled, (state, action) => {
        const team = _.cloneDeep(state.team);
        if (team && team.teamProsCnt) {
          team.teamProsCnt = action.payload.res;
        }
        state.team = team;
      })
      .addCase(editContactsInAccountAllow.fulfilled, (state, action) => {
        const team = _.cloneDeep(state.team);
        if (team && team.teamProsCnt) {
          team.teamProsCnt = action.payload.teamProsCnt;
        }
        state.team = team;
      })
      .addCase(editContactsInAccountStop.fulfilled, (state, action) => {
        const team = _.cloneDeep(state.team);
        if (team && team.teamProsCnt) {
          team.teamProsCnt = action.payload.teamProsCnt;
        }
        state.team = team;
      })
      .addCase(assignContactsInAccountCampaign.fulfilled, (state, action) => {
        const team = _.cloneDeep(state.team);
        if (team && team.teamProsCnt) {
          team.teamProsCnt = action.payload.teamProsCnt;
        }
        state.team = team;
      })
      .addCase(editContactsInAccountCampaign.fulfilled, (state, action) => {
        const team = _.cloneDeep(state.team);
        if (team && team.teamProsCnt) {
          team.teamProsCnt = action.payload.teamProsCnt;
        }
        state.team = team;
      })
      .addCase(editContactsInAccountDelete.fulfilled, (state, action) => {
        const team = _.cloneDeep(state.team);
        if (team && team.teamProsCnt) {
          team.teamProsCnt = action.payload.teamProsCnt;
        }
        state.team = team;
      })
      .addCase(getUser.rejected, (state, action: any) => {
        if (state.loading) {
          state.loading = false;
        }
        // console.log("USERREQ=REJECTED");
        // console.log("Unhandled promise rejection3:", action.error);
        state.error = "Issue getting account";
      })
      .addCase(getProsFiles.fulfilled, (state, action: any) => {
        if (state.user?.id) {
          const deepCopiedUser = _.cloneDeep(state.user);
          deepCopiedUser.prospect_data_credits = action.payload.credits;
          state.payingClient = deepCopiedUser?.new_payment_status === "successfully_on" && deepCopiedUser?.new_subscription_plans;
          state.trialClient = deepCopiedUser?.new_payment_status === "trial" && deepCopiedUser?.new_subscription_plans;
          state.user = deepCopiedUser;
        }
        // console.log(action.payload, "action.payload3")
      })
      .addCase(patchEmailSettings.fulfilled, (state, action: any) => {
        if (state.user?.id) {
          const deepCopiedUser = _.cloneDeep(state.user);
          state.payingClient = deepCopiedUser?.new_payment_status === "successfully_on" && deepCopiedUser?.new_subscription_plans;
          state.trialClient = deepCopiedUser?.new_payment_status === "trial" && deepCopiedUser?.new_subscription_plans;
          deepCopiedUser.first_name = action.payload.firstName;
          state.user = deepCopiedUser;
        }
      })
      .addCase(skipTrialNow.fulfilled, (state, action: any) => {
        const client = action.payload?.user || {};
        state.payingClient = client?.new_payment_status === "successfully_on" && client?.new_subscription_plans;
        state.trialClient = client?.new_payment_status === "trial" && client?.new_subscription_plans;
        // console.log(action.payload, "skipTrialNowskipTrialNow");
        state.user = client;
      })
      .addCase(generateOneAiEmail.fulfilled, (state, action: any) => {
        const deepCopiedUser = _.cloneDeep(state.user);
        const newCredAmnt = deepCopiedUser.ai_personalized_emails_left - 1 < 0 ? 0 : deepCopiedUser.ai_personalized_emails_left - 1;
        deepCopiedUser.ai_personalized_emails_left = newCredAmnt;
        state.user = deepCopiedUser;

        // console.log(action.payload, "action.payload3")
      })
      .addCase(getCustomPaymentId.fulfilled, (state, action: any) => {
        state.planToDisplayLoading = false;

        const res = action.payload;
        console.log(res?.customSignup, "res?.customSignup");
        if (res?.status === "active") {
          state.planToDisplay = res?.customSignup;
        }
      })
      .addCase(getCustomPaymentId.rejected, (state, action: any) => {
        state.planToDisplayLoading = false;
      })

      .addCase(patchSettings.pending, (state) => {
        if (!state.settingsLoading) {
          state.settingsLoading = true;
        }
      })
      .addCase(updateMeeting.fulfilled, (state, action) => {
        const client = action.payload?.client;
        state.payingClient = client?.new_payment_status === "successfully_on" && client?.new_subscription_plans;
        state.trialClient = client?.new_payment_status === "trial" && client?.new_subscription_plans;
        state.user = client;
        state.settings = action.payload?.settings;
      })
      .addCase(patchSettings.fulfilled, (state, action: any) => {
        state.settings = action.payload?.settings;
      })
      .addCase(patchSettings.rejected, (state, action: any) => {
        if (state.settingsLoading) {
          state.settingsLoading = false;
          // console.log(action.error, "error2");
          state.error = action.error;
        }
      })
      .addCase(gettimezones.fulfilled, (state, action: any) => {
        state.timezones = action.payload;
      })
      .addCase(gettimezones.rejected, (state, action: any) => {
        // console.log(action, "timezones err");
      })

      //  TEAMS LOGIC
      .addCase(teamMemCreate.fulfilled, (state, action: any) => {
        state.team = action.payload?.updSuppr;
        const outcome = action.payload?.amntUpl;
        if (typeof outcome === "number") {
          state.successfullUpdateMsgTeam = `Successfully updated ${outcome} team members.`;
        } else if (typeof outcome === "string") {
          state.failedUpdateMsgTeam = state.failedUpdateMsgTeam = outcome;
        }
        state.loadingSaveTeam = false;
      })
      .addCase(teamMemCreate.pending, (state, action: any) => {
        state.loadingSaveTeam = true;
      })
      .addCase(teamMemCreate.rejected, (state, action: any) => {
        state.loadingSaveTeam = false;
        // console.log(action, "timezones err");
        state.failedUpdateMsgTeam = "Something went wrong, please check your internet.";
      })
      .addCase(updRoleInTeam.fulfilled, (state, action: any) => {
        const role = action.payload?.role;
        const outcome = action.payload?.email;
        const isViewerAdded = action.payload?.isViewerAdded;
        const isMe = action.payload?.isMe;
        const inactivated_emails = state.team?.clientWithTeam?.pageInfo?.data?.inactivated_emails;
        const team_members = state.team?.clientWithTeam?.pageInfo?.data?.team_members;

        const teamToUpd = _.cloneDeep(state.team);
        if (inactivated_emails) {
          const inactivatedEmailIndex = inactivated_emails.findIndex((member: any) => member.email === outcome);
          if (inactivatedEmailIndex !== -1) {
            teamToUpd.clientWithTeam.pageInfo.data.inactivated_emails[inactivatedEmailIndex].type = role;
          }
        }

        if (team_members) {
          const teamMemberIndex = team_members.findIndex((member: any) => member.email === outcome);

          if (teamMemberIndex !== -1) {
            const origRole = teamToUpd.clientWithTeam.pageInfo.data.team_members[teamMemberIndex].teamStatus;
            teamToUpd.clientWithTeam.pageInfo.data.team_members[teamMemberIndex].teamStatus = role;
            if (origRole === "viewer" && !isViewerAdded) {
              teamToUpd.clientWithTeam.pageInfo.data.team_members[teamMemberIndex].changed_to_viewer_mode_unix = Math.floor(Date.now() / 1000);
            }
          }
        }

        if (isViewerAdded) {
          teamToUpd.clientWithTeam.teamSeatsRemain = teamToUpd.clientWithTeam.teamSeatsRemain + 1;
        }
        console.log(isMe, "isMeisMe");
        if (isMe) {
          // UPDATE THIS!!
          state.forceUserRefresh = true;
        }

        state.team = teamToUpd;
        state.successfullUpdateMsgTeam = `Updated Role`;
      })
      .addCase(updRoleInTeam.pending, (state, action: any) => {
        // state.loadingSaveTeam = true;
      })
      .addCase(updRoleInTeam.rejected, (state, action: any) => {
        // state.loadingSaveTeam = false;
        // console.log(action, "timezones err");
        state.failedUpdateMsgTeam = "Couldn't update role, please check your internet.";
      })
      .addCase(deleteInTeam.fulfilled, (state, action: any) => {
        // const role = action.payload?.role;
        const email = action.payload?.email;
        // const isViewerAdded = action.payload?.isViewerAdded;
        const isMe = action.payload?.isMe; // DISABLED AND SHOULDNT HAPPEN
        const inactivated_emails = state.team?.clientWithTeam?.pageInfo?.data?.inactivated_emails;
        const team_members = state.team?.clientWithTeam?.pageInfo?.data?.team_members;

        const teamToUpd = _.cloneDeep(state.team);
        if (inactivated_emails) {
          teamToUpd.clientWithTeam.pageInfo.data.inactivated_emails = inactivated_emails.filter(
            (member: any) => member.email?.toLowerCase()?.trim() !== email?.toLowerCase()?.trim()
          );
        }

        if (team_members) {
          teamToUpd.clientWithTeam.pageInfo.data.team_members = team_members.filter(
            (member: any) => member.email?.toLowerCase()?.trim() !== email?.toLowerCase()?.trim()
          );
        }

        // if (isViewerAdded) {
        teamToUpd.clientWithTeam.teamSeatsRemain = teamToUpd.clientWithTeam.teamSeatsRemain + 1;
        // }
        // console.log(isMe, "isMeisMe");
        if (isMe) {
          state.forceUserRefresh = true;
        }

        state.team = teamToUpd;
        state.successfullUpdateMsgTeam = `Deleted Team Member`;
      })
      .addCase(deleteInTeam.pending, (state, action: any) => {
        // state.loadingSaveTeam = true;
      })
      .addCase(deleteInTeam.rejected, (state, action: any) => {
        // state.loadingSaveTeam = false;
        // console.log(action, "timezones err");
        state.failedUpdateMsgTeam = "Couldn't update role, please check your internet.";
      })
      .addCase(updTeamSchedInTeam.fulfilled, (state, action: any) => {
        state.successfullUpdateMsgTeam = `Updated Team`;
      })
      .addCase(updTeamSchedInTeam.pending, (state, action: any) => {
        // state.loadingSaveTeam = true;
      })
      .addCase(updTeamSchedInTeam.rejected, (state, action: any) => {
        // state.loadingSaveTeam = false;
        // console.log(action, "timezones err");
        state.failedUpdateMsgTeam = "Couldn't update role, please check your internet.";
      })
      .addCase(updSchedTeamBe.fulfilled, (state, action: any) => {
        state.successfullUpdateMsgTeam = `Updated Scheduling Group`;
        state.team = action.payload;
        state.editingTeamsLoading = false;
      })
      .addCase(updSchedTeamBe.pending, (state, action: any) => {
        // state.loadingSaveTeam = true;
        state.editingTeamsLoading = true;
      })
      .addCase(updSchedTeamBe.rejected, (state, action: any) => {
        // state.loadingSaveTeam = false;
        // console.log(action, "timezones err");
        state.failedUpdateMsgTeam = "Couldn't update group, please check your internet.";
        state.editingTeamsLoading = false;
      })
      .addCase(editGroupRule.fulfilled, (state, action: any) => {
        state.successfullUpdateMsgTeam = `Updated Scheduling Group Rules`;
        state.team = action.payload;
        // state.editingTeamsLoading = false;
      })
      .addCase(editGroupRule.pending, (state, action: any) => {
        // state.loadingSaveTeam = true;
        // state.editingTeamsLoading = true;
      })
      .addCase(editGroupRule.rejected, (state, action: any) => {
        // state.loadingSaveTeam = false;
        // console.log(action, "timezones err");
        state.failedUpdateMsgTeam = "Couldn't update group, please check your internet.";
        // state.editingTeamsLoading = false;
      })
      .addCase(salesforceConnect.fulfilled, (state, action: any) => {
        state.successfullIntegration = "Connected your Salesforce account successfully";
        state.uplIntegrationLoading = false;
        state.integrationListTeamHas = action.payload || [];
      })
      .addCase(salesforceConnect.pending, (state, action: any) => {
        state.uplIntegrationLoading = "salesforcee";
      })
      .addCase(salesforceConnect.rejected, (state, action: any) => {
        state.failedIntegration = "Could not connect your Salesforce account, make sure you have a paid account in Salesforce";
        state.uplIntegrationLoading = false;
      })
      .addCase(hubspotConnect.fulfilled, (state, action: any) => {
        state.successfullIntegration = "Connected your Hubspot account successfully";
        state.uplIntegrationLoading = false;
        state.integrationListTeamHas = action.payload || [];
      })
      .addCase(hubspotConnect.pending, (state, action: any) => {
        state.uplIntegrationLoading = "hubspot";
      })
      .addCase(hubspotConnect.rejected, (state, action: any) => {
        state.failedIntegration = "Could not connect your Hubspot account, make sure you have a paid account in Hubspot";
        state.uplIntegrationLoading = false;
      })
      .addCase(apolloConnect.fulfilled, (state, action: any) => {
        state.successfullIntegration = "Connected your Apollo account successfully";
        state.uplIntegrationLoading = false;
        state.integrationListTeamHas = action.payload || [];
      })
      .addCase(apolloConnect.pending, (state, action: any) => {
        state.uplIntegrationLoading = "apollo";
      })
      .addCase(apolloConnect.rejected, (state, action: any) => {
        state.failedIntegration = "Could not connect your Apollo account, make sure you have a paid account in Apollo";
        state.uplIntegrationLoading = false;
      })
      .addCase(saveDialerMapping.fulfilled, (state, action: any) => {
        state.successfullIntegration = "Saved dialer dispositions";
        // state.uplIntegrationLoading = false;
        state.integrationListTeamHas = action.payload || [];
      })
      .addCase(saveDialerMapping.pending, (state, action: any) => {
        // state.uplIntegrationLoading = "apollo";
      })
      .addCase(saveDialerMapping.rejected, (state, action: any) => {
        state.failedIntegration = "Something went wrong, please check your internet and retry to save";
        // state.uplIntegrationLoading = false;
      })
      .addCase(saveTeamConnection.fulfilled, (state, action: any) => {
        state.successfullIntegration = "Saved your teams connection to Apollo";
        // state.uplIntegrationLoading = false;
        state.integrationListTeamHas = action.payload || [];
      })
      .addCase(saveTeamConnection.pending, (state, action: any) => {
        // state.uplIntegrationLoading = "apollo";
      })
      .addCase(saveTeamConnection.rejected, (state, action: any) => {
        state.failedIntegration = "Something went wrong, please check your internet and retry to save";
        // state.uplIntegrationLoading = false;
      })
      .addCase(getIntegrationLeadsHubspot.fulfilled, (state, action: any) => {
        // console.log(action.payload, "getIntegrationLeadsHubspot");
        state.hubspotTotalCnt = action.payload?.total || 0;
        // state.successfullIntegration = "Connected your Apollo account successfully";
        state.fetchingExtLeadsLoading = false;
      })
      .addCase(getIntegrationLeadsHubspot.pending, (state, action: any) => {
        state.fetchingExtLeadsLoading = true;
      })
      .addCase(getIntegrationLeadsHubspot.rejected, (state, action: any) => {
        state.hubspotTotalCnt = "Error";
        // state.failedIntegration = "Could not connect your Apollo account, make sure you have a paid accounnt in Apollo";
        state.fetchingExtLeadsLoading = false;
      })
      .addCase(getIntegrationLeadsSalesforce.fulfilled, (state, action: any) => {
        console.log(action.payload, "getIntegrationLeadsSalesforce");
        const arr = action?.payload || [];
        const total = arr?.map((item: any) => item?.total)?.reduce((acc: any, curr: any) => acc + curr, 0);
        state.salesforceTotalCnt = total || 0;
        // state.successfullIntegration = "Connected your Apollo account successfully";
        state.fetchingExtLeadsLoading = false;
      })
      .addCase(getIntegrationLeadsSalesforce.pending, (state, action: any) => {
        state.fetchingExtLeadsLoading = true;
      })
      .addCase(getIntegrationLeadsSalesforce.rejected, (state, action: any) => {
        state.salesforceTotalCnt = "Error";
        // state.failedIntegration = "Could not connect your Apollo account, make sure you have a paid accounnt in Apollo";
        state.fetchingExtLeadsLoading = false;
      })
      .addCase(getIntegrationLeadsApollo.fulfilled, (state, action: any) => {
        // console.log(action.payload, "getIntegrationLeadsApollo");
        state.apolloTotalCnt = action.payload?.pagination?.total_entries || 0;
        // state.successfullIntegration = "Connected your Apollo account successfully";
        state.fetchingExtLeadsLoading = false;
      })
      .addCase(getIntegrationLeadsApollo.pending, (state, action: any) => {
        state.fetchingExtLeadsLoading = true;
      })
      .addCase(getIntegrationLeadsApollo.rejected, (state, action: any) => {
        state.apolloTotalCnt = "Error";
        // state.failedIntegration = "Could not connect your Apollo account, make sure you have a paid accounnt in Apollo";
        state.fetchingExtLeadsLoading = false;
      })
      .addCase(apolloGetInformation.fulfilled, (state, action: any) => {
        state.fetchingApolloLeadsDataLoading = false;
        state.teamLeadsHave = action.payload || [];
      })
      .addCase(apolloGetInformation.pending, (state, action: any) => {
        state.fetchingApolloLeadsDataLoading = true;
      })
      .addCase(apolloGetInformation.rejected, (state, action: any) => {
        state.fetchingApolloLeadsDataLoading = false;
        state.teamLeadsHave = [];
      })
      .addCase(salesforceGetInformation.fulfilled, (state, action: any) => {
        state.fetchingSalesforceLeadsDataLoading = false;
        state.teamLeadsHaveSalesforce = action.payload || [];
      })
      .addCase(salesforceGetInformation.pending, (state, action: any) => {
        state.fetchingSalesforceLeadsDataLoading = true;
      })
      .addCase(salesforceGetInformation.rejected, (state, action: any) => {
        state.fetchingSalesforceLeadsDataLoading = false;
        state.teamLeadsHaveSalesforce = [];
      })
      .addCase(hubspotGetInformation.fulfilled, (state, action: any) => {
        state.fetchingHubspotLeadsDataLoading = false;
        state.teamLeadsHaveHubspot = action.payload || [];
      })
      .addCase(hubspotGetInformation.pending, (state, action: any) => {
        state.fetchingHubspotLeadsDataLoading = true;
      })
      .addCase(hubspotGetInformation.rejected, (state, action: any) => {
        state.fetchingHubspotLeadsDataLoading = false;
        state.teamLeadsHaveHubspot = [];
      });
  },
});

const { actions, reducer } = userSlice;

export const {
  logout,
  hideTutorialNow,
  ShowTutorialNow,
  setUser,
  setError,
  setNotificationsInsist,
  // toggleTutorialStatus,
  // setStepOfTutorial,
  setTutorialRun,
  SetColapsedSdBar,
  setSkipTrial,
  resOutcomeTeam,
  updPersSchedGroup,
  idArrExpectedToSee,
  closeAssigningArr,
  resetIntegrationStat,
  resetLeadUplStat,
} = actions;

export default reducer;

export const fullUserSelector = createSelector(
  (state) => state.user,
  (user) => user
);

export const userSelector = createSelector(
  (state) => state.user,
  (user) => user.user
);
export const teamSelector = createSelector(
  (state) => state.user,
  (user) => user.team
);
export const userIsPayingSelector = createSelector(
  (state) => state.user,
  (user) => user.payingClient // doesnt work for team mems?
  // (user) => true
);
export const userIsTrialSelector = createSelector(
  (state) => state.user,
  (user) => user.trialClient
);

export const settingsSelector = createSelector(
  (state) => state.user,
  (user) => user.settings
);

export const tokenSelector = createSelector(
  (state) => state.user,
  (user) => user.token
);

export const errorSelector = createSelector(
  (state) => state.user,
  (user) => user.error
);
